// src/features/operational/components/subject/SubjectManagement.js
import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Paper, 
  Tabs, 
  Tab, 
  Typography, 
  useMediaQuery,
  useTheme,
  CircularProgress
} from '@mui/material';
import {
  AutoStories as PlanningIcon,
  Inventory as ResourcesIcon,
  School as TeachingIcon,
  AssignmentTurnedIn as AssessmentIcon,
  FactCheck as ModerationIcon
} from '@mui/icons-material';
import { useAuth } from '../../../../contexts/AuthContext';
import { THEME_COLORS } from '../../../../styles/theme';
import SubjectPlanning from './SubjectPlanning';
import SubjectResources from './SubjectResources';


const SubjectManagement = () => {
  const [activeTab, setActiveTab] = useState('planning');
  const [loading, setLoading] = useState(true);
  const { currentUser, userProfile } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  useEffect(() => {
    // Check if user is authenticated
    if (currentUser) {
      setLoading(false);
    }
  }, [currentUser]);
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  const renderContent = () => {
    if (loading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={4}>
          <CircularProgress sx={{ color: THEME_COLORS.primary }} />
        </Box>
      );
    }
    
    switch (activeTab) {
      case 'planning':
        return <SubjectPlanning userId={currentUser?.uid} />;
      case 'resources':
        return <SubjectResources userId={currentUser?.uid} />;
      
      default:
        return <SubjectPlanning userId={currentUser?.uid} />;
    }
  };
  
  return (
    <Box>
      <Paper 
        elevation={2} 
        sx={{ 
          p: 2, 
          mb: 3, 
          borderRadius: 2
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
          indicatorColor="primary"
          textColor="primary"
          sx={{
            '& .MuiTab-root': {
              minHeight: 48,
              textTransform: 'none',
              fontWeight: 600
            },
            '& .Mui-selected': {
              color: THEME_COLORS.primary
            },
            '& .MuiTabs-indicator': {
              backgroundColor: THEME_COLORS.primary
            }
          }}
        >
          <Tab 
            icon={<PlanningIcon />} 
            iconPosition="start" 
            label="Subject Planning" 
            value="planning" 
          />
          <Tab 
            icon={<ResourcesIcon />} 
            iconPosition="start" 
            label="Subject Resources" 
            value="resources" 
          />
          <Tab 
            icon={<ModerationIcon />} 
            iconPosition="start" 
            label="Moderation" 
            value="moderation" 
          />
        </Tabs>
      </Paper>
      
      {/* Render the content based on active tab */}
      <Box>
        {renderContent()}
      </Box>
    </Box>
  );
};

export default SubjectManagement;